var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"heading":`${_vm.$t('actions.create')} ${_vm.$tc('models.user')}`}},[_c('building-user-form',{attrs:{"user":_vm.user},on:{"submit":_vm.handleSubmit,"cancel":_vm.handleCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }